import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { environment } from '../../../environments/environment';
import { catchError, throwError } from 'rxjs';

/**
 * Returns true when the request targets the PDMA backend API.
 * Handles both relative (/api/...) and absolute URLs after apiUrlInterceptor rewrites.
 */
function isApiRequest(url: string): boolean {
  if (url.startsWith('/api')) return true;
  if (environment.apiUrl && url.startsWith(environment.apiUrl)) return true;
  return false;
}

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const token = authService.getToken();
  if (token && isApiRequest(req.url)) {
    req = req.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    });
  }

  return next(req).pipe(
    catchError((error) => {
      if (error.status === 401) {
        authService.logout();
        router.navigate(['/login']);
      }
      return throwError(() => error);
    }),
  );
};
